// extracted by mini-css-extract-plugin
export default {"main":"AuthorInfo_main__glx7P","image":"AuthorInfo_image__VjgGF"};